import { FC, HTMLAttributes, ReactNode } from 'react';
import classNames from 'classnames';
import Hint from './Hint';
import st from './GroupControl.module.scss';

interface IGroupControlProps extends HTMLAttributes<HTMLDivElement> {
	name?: string;
	row?: boolean;
	hint?: string;
	renderToolbar?: () => ReactNode;
}

const GroupControl: FC<IGroupControlProps> = ({
	name,
	row = false,
	hint = '',
	children,
	className,
	title,
	renderToolbar,
	...otherProps
}) => {
	return (
		<div
			className={classNames(st.groupControl, className, {
				[st.row]: row,
			})}
			{...otherProps}
		>
			{(!!title || !!renderToolbar) && (
				<div className={st.groupControlHeader}>
					<span>{title}</span>
					{!!hint && <Hint label={title}>{hint}</Hint>}
					{!!renderToolbar && renderToolbar()}
				</div>
			)}
			{children}
		</div>
	);
};

export default GroupControl;
